import { Section, Stack, Text } from '@/ui';
import { PageShell } from '@/ui/primitives/PageShell';
import type { ReactElement } from 'react';

export const ReportsPage = (): ReactElement => {
  return (
    <PageShell maxWidth="lg" paddingX="lg" paddingY="xl" paddingBottom="xl">
      <Stack gap="lg">
        <Section>
          <Text role="pageTitle">Reports</Text>
        </Section>
      </Stack>
    </PageShell>
  );
};
